export const kingDeath = new Image();
kingDeath.src = "./assets/characterSprites/king/kingDeath3.png";
kingDeath.width = 1280/8
kingDeath.height = 111
kingDeath.yOffset = 38
kingDeath.xOffset = 150
kingDeath.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];